import { BookmarkedRecipesCollectionRef } from 'services/firebase';

const wasBookmarked = async (recipeID, userID) => {
  if (!recipeID) throw new Error('recipeID cannot be empty');
  if (!userID) throw new Error('userID cannot be empty');

  const bookmarkedKey = `${recipeID}.${userID}`;

  const bookmarkedDoc = await BookmarkedRecipesCollectionRef()
    .doc(bookmarkedKey)
    .get();

  if (!bookmarkedDoc.exists) return false;

  return bookmarkedDoc.data().bookmarked;
};

export default wasBookmarked;
